import api from "../utils/API";

const getAllEffectif = () => {
  return api.get(`/AllEffectif/list`);
};

export {getAllEffectif};